import React, { useEffect, useState, useMemo } from 'react';
import { TextField, Button, Box, DialogActions, DialogContent, DialogTitle
  , useMediaQuery, Dialog, Snackbar, Paper, Select, MenuItem, Typography } from '@mui/material';
import { themeQuartz } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useTheme } from '@mui/material/styles';
import { useOrdersMutation } from '../../services/ecom';
import * as XLSX from 'xlsx';
import ConfirmDialog from '../tools/comfirmDialog';
import LoadingPage from '../loadingPage';

export default function ImportExcel({open, setOpen, selectedSMS}) {
  const theme1 = useTheme();
  const fullScreen = useMediaQuery(theme1.breakpoints.down('md'));
	const [loading, setLoading] = useState(false);
	const [orders, ordersResult] = useOrdersMutation();
  const [alert, setAlert] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [columns, setColumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [platform, setPlatform] = useState('web');

  useEffect(() => {
    setGridHeight(window.innerHeight - 210);
  }, []);

  const handleClose = () => {
    setOpen(false);
    setExcelData([]);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true);
      setTimeout(() => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[workbook.SheetNames.length > 1 ? 1 : 0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            range: platform == 'web' ? 10 : 0,
            raw: false,
            dateNF: "yyyy-mm-dd"
          });
          let filtered = [];
          if(platform == 'web'){
            filtered = json.map(row => ({
              transactionid: row["Mã đơn hàng shop"]?.split("-")[0].replace('#', ''),
              delistatus: row["Trạng thái đơn hàng"]
            })).filter(row => !isNaN(row.transactionid) && row.delistatus);
          }
          else if(platform == 'shopee'){
            filtered = Object.values(
              json.reduce((acc, row) => {
                const id = row["Mã đơn hàng"];
                const status = row["Trạng Thái Đơn Hàng"]?.toLowerCase().trim();

                if (id && status && (status == 'đã giao' || status == 'hoàn thành')) {// || status.includes('đã nhận')
                  acc[id] = { transactionid: id, delistatus: status };
                }
                return acc;
              }, {})
            );
          }
          else if(platform == 'lazada'){
            filtered = Object.values(
              json.reduce((acc, row) => {
                const id = row["orderNumber"];
                const status = row["status"]?.toLowerCase().trim();

                if (id && status && (status == 'delivered' || status == 'confirmed')) {
                  acc[id] = { transactionid: id, delistatus: status };
                }
                return acc;
              }, {})
            );
          }
          setExcelData(filtered);
          filtered.length > 0 &&
            getColumns(filtered[0]);

        };
        reader.readAsArrayBuffer(file);

        setLoading(false);
      }, 100);
    }
  };

  const getColumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key, width: 150
      }
    });
    setColumns(cols);
  }

  const myTheme = themeQuartz.withParams({
    wrapperBorder: false,
    headerRowBorder: false,
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const onSave = async() =>{
		setLoading(true);
    try {
      setConfirm(false);
      let error = false;
      let ids = '';
      if(platform == 'web')
			  ids = excelData.filter(f=>f.delistatus === 'Đã đối soát').map(node => node.transactionid);
      else
        ids = excelData.map(node => node.transactionid);

			const formData = new FormData();
			formData.append("data", JSON.stringify({"type": `saveImport${open}`, "ids": ids.toString()
																								, "value": 'Giao thành công', platform: platform}));
			const dt = await orders(formData).unwrap();
			if(dt[0].ERROR) error = dt[0].ERROR;
      
      if(error)
        setAlert(error);
      else{
        setAlert(`Đã cập nhật ${ids.length} đơn hàng!`);
				setExcelData([]);
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
		setLoading(false);
  }

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" sx={{textAlign: 'center', fontWeight: 600}}>
          <Typography variant="body2" style={{float: 'left', marginTop: '10px', marginRight: '5px'}}>
            {open}
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={platform}
            label=""
            onChange={(e)=>setPlatform(e.target.value)}
            style={{width: '200px', float: 'left'}}
            size='small'
          >
            <MenuItem value={'web'}>Web</MenuItem>
            <MenuItem value={'shopee'}>Shopee</MenuItem>
            <MenuItem value={'lazada'}>Lazada</MenuItem>
          </Select>
        </DialogTitle>
                {/* <Divider /> */}
        <DialogContent>
          { (loading) && <LoadingPage /> }
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
            <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
              <AgGridReact enableCellTextSelection={true} ensureDomOrder={true}
                rowData={excelData}
                columnDefs={columns}
                pagination={true}
                paginationPageSize={200}
                paginationPageSizeSelector={[200, 500, 1000]}
                theme={theme}
                loading={loading}
              />
            </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            CLOSE
          </Button>
          <Button onClick={()=>setConfirm("Xác nhận hệ thống sẽ cập nhật những đơn có trạng thái chưa xử lý sang giao thành công?")} autoFocus>
            SAVE
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />

      <ConfirmDialog confirm={confirm} setConfirm={setConfirm} onConfirm={onSave}/>
    </React.Fragment>
  );
}